import { backupApi } from '../../api';
import {
  BackupConfigurationUpdateDTO,
  BackupHistoryPage,
} from '../../types/settings/backup';
import { ApiResponse } from '../../types/common/ApiResponse';

const BackupService = {
  getConfiguration: async () => {
    const response = await backupApi.fetchCustom('/configuration');
    return response.data;
  },

  updateConfiguration: async (payload: BackupConfigurationUpdateDTO) => {
    const response = await backupApi.modifyCustom('/configuration', payload);
    return response.data;
  },

  getHistory: async (page = 0, size = 10) => {
    const response = await backupApi.fetchCustom(
      `/history?page=${page}&size=${size}&sort=startedAt,desc`
    );
    return response.data as BackupHistoryPage;
  },

  runBackup: async () => {
    const response = await backupApi.addWithoutData('/run');
    return response.data as ApiResponse<any>;
  },
};

export default BackupService;
